import { useCallback } from 'react';

import { useGenericSend } from '../useGenericSend';
import * as Types from './types';

export const useInboxSendMessage = () => {
    const send = useGenericSend();

    return useCallback(async (request: Types.IInboxSendMessageRequestData): Promise<Types.IInboxSendMessageResponseData> => {
        const { data } = await send<Types.IInboxSendMessageRequestData, Types.IInboxSendMessageResponseData>({
            ID: 70003,
            responses: [70004],
            description: 'Inbox Send Message',
            ...request
        });

        return data;
    }, [
        send
    ]);
};
